import { render, staticRenderFns } from "./IntegrationsHelpDialogKanban.vue?vue&type=template&id=0fb2a352&scoped=true&"
import script from "./IntegrationsHelpDialogKanban.vue?vue&type=script&lang=js&"
export * from "./IntegrationsHelpDialogKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2a352",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsHelpDialogKanban.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
